// eslint-disable-next-line import/no-cycle
import ActionWaitMetadata from '@/components/automated-scenarios/metadata/actions/ActionWaitMetadata';
// eslint-disable-next-line import/no-cycle
import ActionDelaisMaxMetadata from '@/components/automated-scenarios/metadata/actions/ActionDelaisMaxMetadata';
// eslint-disable-next-line import/no-cycle
import ActionTagMetadata from '@/components/automated-scenarios/metadata/actions/ActionTagMetadata';
// eslint-disable-next-line import/no-cycle
import ActionListMetadata from '@/components/automated-scenarios/metadata/actions/ActionListMetadata';
// eslint-disable-next-line import/no-cycle
import ActionSendEmailMetadata from '@/components/automated-scenarios/metadata/actions/ActionSendEmailMetadata';
// eslint-disable-next-line import/no-cycle
import ActionSendSmsMetadata from '@/components/automated-scenarios/metadata/actions/ActionSendSmsMetadata';
// eslint-disable-next-line import/no-cycle
import ActionSendRCSMetadata from '@/components/automated-scenarios/metadata/actions/ActionSendRCSMetadata';
// eslint-disable-next-line import/no-cycle
import ActionSendWhatsappMetadata from '@/components/automated-scenarios/metadata/actions/ActionSendWhatsappMetadata';
// eslint-disable-next-line import/no-cycle
import ActionDisplayFreePopupMetadata
  from '@/components/automated-scenarios/metadata/actions/ActionDisplayFreePopupMetadata';
// eslint-disable-next-line import/no-cycle
import ActionDisplayFreeModelMetadata
  from '@/components/automated-scenarios/metadata/actions/ActionDisplayFreeModelMetadata';
// eslint-disable-next-line import/no-cycle
import ActionSendFbMessengerMetadata
  from '@/components/automated-scenarios/metadata/actions/ActionSendFbMessengerMetadata';
// eslint-disable-next-line import/no-cycle
import ActionSendPushNotificationMetadata
  from '@/components/automated-scenarios/metadata/actions/ActionSendPushNotificationMetadata';
// eslint-disable-next-line import/no-cycle
import ActionABTestMetadata from '@/components/automated-scenarios/metadata/actions/ActionABTestMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurAbandonPanierMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurAbandonPanierMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurCollectAnonymousVisitorMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurCollectAnonymousVisitorMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurStatusCommandMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurStatusCommandMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurVisitPageMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurVisitPageMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurSitePassTimeMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurSitePassTimeMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurRegisterOnSiteMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurRegisterOnSiteMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurSubscribeToNewsletterMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurSubscribeToNewsletterMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurScrollPageMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurScrollPageMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurQuitSiteMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurQuitSiteMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurPeriodicLaunchingMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurPeriodicLaunchingMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurChooseBulkListMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurChooseBulkListMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurCustomJSMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurCustomJSMetadata';
// eslint-disable-next-line import/no-cycle
import DeclencheurTriggerInternalEventMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurTriggerInternalEventMetadata';
// eslint-disable-next-line import/no-cycle
import FiltreCurrentCartMetadata from '@/components/automated-scenarios/metadata/filtres/FiltreCurrentCartMetadata';
// eslint-disable-next-line import/no-cycle
import FiltreCurrentOrderMetadata from '@/components/automated-scenarios/metadata/filtres/FiltreCurrentOrderMetadata';
// eslint-disable-next-line import/no-cycle
import FiltreCustomerMetadata from '@/components/automated-scenarios/metadata/filtres/FiltreCustomerMetadata';
// eslint-disable-next-line import/no-cycle
import FiltrePurchaseHistoryMetadata from '@/components/automated-scenarios/metadata/filtres/FiltrePurchaseHistoryMetadata';
// eslint-disable-next-line import/no-cycle
import FiltreBoxNavigationTriggerMetadata
  from '@/components/automated-scenarios/metadata/filtres/FiltreBoxNavigationTriggerMetadata';
// eslint-disable-next-line import/no-cycle
import FiltreOpenEmailMetadata from '@/components/automated-scenarios/metadata/filtres/FiltreOpenEmailMetadata';
// eslint-disable-next-line import/no-cycle
import FiltreClicklinkMetadata from '@/components/automated-scenarios/metadata/filtres/FiltreClicklinkMetadata';
// eslint-disable-next-line import/no-cycle
import FiltreFilledoutFormMetadata from '@/components/automated-scenarios/metadata/filtres/FiltreFilledoutFormMetadata';
// eslint-disable-next-line import/no-cycle
import FiltreActionOnCampaignMetadata
  from '@/components/automated-scenarios/metadata/filtres/FiltreActionOnCampaignMetadata';
// eslint-disable-next-line import/no-cycle
import { ComponentMetadata } from '@/types/automated-scenarios';
// eslint-disable-next-line import/no-cycle
import DeclencheurAudienceSetupMetadata
  from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurAudienceSetupMetadata';
// eslint-disable-next-line import/no-cycle
import FiltreContactSegmentationMetadata
  from '@/components/automated-scenarios/metadata/filtres/FiltreContactSegmentationMetadata';

const Metadata = {
  ActionWaitMetadata,
  ActionDelaisMaxMetadata,
  ActionTagMetadata,
  ActionListMetadata,
  ActionSendEmailMetadata,
  ActionSendSmsMetadata,
  ActionDisplayFreePopupMetadata,
  ActionDisplayFreeModelMetadata,
  ActionSendFbMessengerMetadata,
  ActionSendPushNotificationMetadata,
  // ActionSendRCSMetadata,
  ActionSendWhatsappMetadata,
  ActionABTestMetadata,
  DeclencheurTriggerInternalEventMetadata,
  DeclencheurAbandonPanierMetadata,
  DeclencheurCollectAnonymousVisitorMetadata,
  DeclencheurStatusCommandMetadata,
  DeclencheurVisitPageMetadata,
  DeclencheurSitePassTimeMetadata,
  DeclencheurRegisterOnSiteMetadata,
  DeclencheurSubscribeToNewsletterMetadata,
  DeclencheurScrollPageMetadata,
  DeclencheurQuitSiteMetadata,
  DeclencheurPeriodicLaunchingMetadata,
  DeclencheurCustomJSMetadata,
  DeclencheurChooseBulkListMetadata,
  DeclencheurAudienceSetupMetadata,
  FiltreContactSegmentationMetadata,
  FiltreCurrentCartMetadata,
  FiltreCurrentOrderMetadata,
  FiltreCustomerMetadata,
  FiltrePurchaseHistoryMetadata,
  FiltreBoxNavigationTriggerMetadata,
  FiltreOpenEmailMetadata,
  FiltreClicklinkMetadata,
  FiltreFilledoutFormMetadata,
  FiltreActionOnCampaignMetadata,
};

export default Metadata;

export function getComponentById(id: string) {
  switch (id) {
    case 'boxabtest':
      return 'ActionABTest';
    case 'boxdelaismax':
      return 'ActionDelaisMax';
    case 'boxdisplayfreemodel':
      return 'ActionDisplayFreeModel';
    case 'boxdisplayfreepopup':
      return 'ActionDisplayFreePopup';
    case 'boxlist':
      return 'ActionList';
    case 'boxsendemail':
      return 'ActionSendEmail';
    case 'boxsendfbmessenger':
      return 'ActionSendFbMessenger';
    case 'boxsendpushnotification':
      return 'ActionSendPushNotification';
    case 'boxsendsms':
      return 'ActionSendSms';
    case 'boxtag':
      return 'ActionTag';
    case 'boxwait':
      return 'ActionWait';
    // case 'boxsendrcs':
    //   return 'ActionSendRCS';
    case 'boxsendwhatsapp':
      return 'ActionSendWhatsapp';

    case 'boxabandonpanier':
      return 'DeclencheurAbandonPanier';
    case 'boxcollectanonymousvisitordata':
      return 'DeclencheurCollectAnonymousVisitor';
    case 'boxcustomjs':
      return 'DeclencheurCustomJS';
    case 'boxperiodiclaunching':
      return 'DeclencheurPeriodicLaunching';
    case 'boxquitsite':
      return 'DeclencheurQuitSite';
    case 'registeronsite':
      return 'DeclencheurRegisterOnSite';
    case 'boxscrollpage':
      return 'DeclencheurScrollPage';
    case 'boxsitepasstime':
      return 'DeclencheurSitePassTime';
    case 'boxtriggerinternalevent':
      return 'DeclencheurTriggerInternalEvent';

    case 'boxstatuscommand':
      return 'DeclencheurStatusCommand';
    case 'subscribetonewsletter':
      return 'DeclencheurSubscribeToNewsletter';
    case 'boxvisitpage':
      return 'DeclencheurVisitPage';
    case 'boxchoosebulklist':
      return 'DeclencheurChooseBulkList';
    case 'boxaudiencesetup':
      return 'DeclencheurAudienceSetup';
    case 'actionOnCampaign':
      return 'FiltreActionOnCampaign';
    case 'boxfiltre_1':
      return 'FiltreCurrentCart';
    case 'boxfiltre_2':
      return 'FiltreCurrentOrder';
    case 'boxfiltre_3':
      return 'FiltreCustomer';
    case 'boxfiltre_4':
      return 'FiltrePurchaseHistory';
    case 'boxnavigationtrigger':
      return 'FiltreBoxNavigationTrigger';
    case 'clicklink':
      return 'FiltreClicklink';
    case 'filledoutform':
      return 'FiltreFilledoutForm';
    case 'openemail':
      return 'FiltreOpenEmail';
    case 'boxcontactseg':
      return 'FiltreContactSegmentation';

    default:
      return '';
  }
}

export function getComponentMetadata(component: string): ComponentMetadata<any> | null {
  switch (component) {
    case 'ActionWait':
      return ActionWaitMetadata;
    case 'ActionDelaisMax':
      return ActionDelaisMaxMetadata;
    case 'ActionTag':
      return ActionTagMetadata;
    case 'ActionList':
      return ActionListMetadata;
    case 'ActionSendEmail':
      return ActionSendEmailMetadata;
    case 'ActionSendSms':
      return ActionSendSmsMetadata;
    // case 'ActionSendRCS':
    //   return ActionSendRCSMetadata;
    case 'ActionSendWhatsapp':
      return ActionSendWhatsappMetadata;
    case 'ActionDisplayFreePopup':
      return ActionDisplayFreePopupMetadata;
    case 'ActionDisplayFreeModel':
      return ActionDisplayFreeModelMetadata;
    case 'ActionSendFbMessenger':
      return ActionSendFbMessengerMetadata;
    case 'ActionSendPushNotification':
      return ActionSendPushNotificationMetadata;
    case 'ActionABTest':
      return ActionABTestMetadata;
    case 'DeclencheurAbandonPanier':
      return DeclencheurAbandonPanierMetadata;
    case 'DeclencheurCollectAnonymousVisitor':
      return DeclencheurCollectAnonymousVisitorMetadata;
    case 'DeclencheurStatusCommand':
      return DeclencheurStatusCommandMetadata;
    case 'DeclencheurVisitPage':
      return DeclencheurVisitPageMetadata;
    case 'DeclencheurSitePassTime':
      return DeclencheurSitePassTimeMetadata;
    case 'DeclencheurRegisterOnSite':
      return DeclencheurRegisterOnSiteMetadata;
    case 'DeclencheurSubscribeToNewsletter':
      return DeclencheurSubscribeToNewsletterMetadata;
    case 'DeclencheurScrollPage':
      return DeclencheurScrollPageMetadata;
    case 'DeclencheurQuitSite':
      return DeclencheurQuitSiteMetadata;
    case 'DeclencheurPeriodicLaunching':
      return DeclencheurPeriodicLaunchingMetadata;
    case 'DeclencheurCustomJS':
      return DeclencheurCustomJSMetadata;
    case 'DeclencheurChooseBulkList':
      return DeclencheurChooseBulkListMetadata;
    case 'DeclencheurAudienceSetup':
      return DeclencheurAudienceSetupMetadata;
    case 'DeclencheurTriggerInternalEvent':
      return DeclencheurTriggerInternalEventMetadata;
    case 'FiltreCurrentCart':
      return FiltreCurrentCartMetadata;
    case 'FiltreCurrentOrder':
      return FiltreCurrentOrderMetadata;
    case 'FiltreCustomer':
      return FiltreCustomerMetadata;
    case 'FiltrePurchaseHistory':
      return FiltrePurchaseHistoryMetadata;
    case 'FiltreBoxNavigationTrigger':
      return FiltreBoxNavigationTriggerMetadata;
    case 'FiltreOpenEmail':
      return FiltreOpenEmailMetadata;
    case 'FiltreClicklink':
      return FiltreClicklinkMetadata;
    case 'FiltreFilledoutForm':
      return FiltreFilledoutFormMetadata;
    case 'FiltreActionOnCampaign':
      return FiltreActionOnCampaignMetadata;
    case 'FiltreContactSegmentation':
      return FiltreContactSegmentationMetadata;
    default:
      return null;
  }
}

export function getComponentMetadataById(id: string): ComponentMetadata<any> | null {
  const component = getComponentById(id);
  return getComponentMetadata(component);
}
